<template lang="pug">
el-dialog(v-dialogDrag :title="isView?'查看表单':'编辑表单'" :visible.sync="dataDialog" width="400px" :before-close="handleClose")
  el-form(ref="form" :model="form" label-width="100px" size="small" label-position="top" :rules="rules")
    el-form-item(label="表单名称" prop="formName")
      el-input(v-model="form.formName", clearable maxlength="30" show-word-limit :disabled="isView")
    el-form-item(label="表单编号" prop="formCode")
      el-input(v-model="form.formCode", clearable maxlength="30" show-word-limit disabled)
    el-form-item(label="关联业务模型" prop="primaryMetaName")
      el-select(v-model="form.primaryMetaName" disabled)
        el-option(v-for="item in metaList" :key="item.tableName" :value="item.tableName" :label="item.businessName")
    el-form-item(label="表单初始布局" prop="layoutType")
      el-radio(v-model="form.layoutType" :label="1" :disabled="isView") 一栏
      el-radio(v-model="form.layoutType" :label="2" :disabled="isView") 二栏
      el-radio(v-model="form.layoutType" :label="3" :disabled="isView") 三栏
    el-form-item(label="表单页描述" prop="remark")
      el-input(v-model="form.remark" type="textarea" maxlength="50" show-word-limit :disabled="isView")
  div(slot="footer" v-if="!isView")
    el-button(@click="handleClose" size="small") 取 消
    el-button(type="primary" @click="onSubmit" size="small") 确 定
</template>

<script>
import metadataService from "@/CommonDP/service/metadata-service.js";
export default {
  props: {
    isView: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      type: "", // "add" :新增；"edit":编辑
      dataDialog: false,
      metaList: [], //
      form: {
        groupId: '',
        groupName: '',
        formName: '',
        formCode: '',
        primaryMetaName: '',
        remark: '',
        layoutType: 1
      },
      rules: {
        formName: [{ required: true, message: ' ', trigger: 'blur' }],
        formCode: [{ required: true, message: ' ', trigger: 'blur' }],
        primaryMetaName: [{ required: true, message: ' ', trigger: 'change' }],
        layoutType: [{ required: true, message: ' ', trigger: 'change' }]
      }
    };
  },
  methods: {
    // 添加
    async editForm(data) {
      this.dataDialog = true;
      console.log("data", data);
      this.form = { ...data };
      this.form.groupId = data.formGroupId;
      this.form.groupName = data?.formGroupName;
      this.queryDynMetaListByGroupID();
    },
    handleClose() {
      this.dataDialog = false;
    },
    async queryDynMetaListByGroupID() {
      const res = await metadataService.queryDynMetaListByGroupID(this.form.groupId);
      this.metaList = res.data || [];
    },
    /** @description: 新增参数描述
     * @param {formId} 新增传空表单ID
     * @param {formName} 表单名称
     * @param {formCode} 表单编号
     * @param {remark} 表单描述
     * @param {formGroupId} 分组ID
     * @param {formGroupName} 分组名称
     * @param {isPublish}  是否发布0:未发布 1:发布 默认0
     * @param {primaryMetaName} 主元数据对象
     * @param {otherMetaNames} 参与元数据对象 默认空
     * @param {stdFormName} 关联标准表单编号 默认空
     * @param {flowKey} 关联流程编号 默认空
     */
    async onSubmit() {
      const { formId, groupId, groupName, formName, formCode, remark, primaryMetaName, layoutType } = this.form;
      const params = {
        formId,
        formGroupId: groupId,
        formGroupName: groupName,
        layoutType,
        formName,
        formCode,
        primaryMetaName,
        isPublish: 0,
        remark,
        otherMetaNames: '',
        stdFormName: '',
        flowKey: ''
      };
      try {
        await metadataService.dynFormUpdate(params);
        this.$success("修改成功!");
        this.$emit('initTree');
        this.form = {};
      } catch (error) {
        console.log(error);
      }
      this.dataDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped></style>

